import { ComponentType } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { Roles } from 'src/enums/roles.enum';
import { useAuth } from '../../hooks';
import { Loader } from '../loader';
import { ApplicationsAdmin } from './applications-admin';
import { ApplicationsEditForm } from './applications-edit-form';
import { ApplicationsUser } from './applications-user';

export const Applications: ComponentType = () => {
  const { user } = useAuth();

  if (!user.data) return null;

  const applicationsView = () => {
    if (user?.isLoading) return <Loader minHeight="50vh" />;
    if (user?.data?.role === Roles.APPLICANT) return <ApplicationsUser />;
    return <ApplicationsAdmin />;
  };

  return (
    <Switch>
      <Route path={ROUTES.APPLICATIONS.CREATE} component={ApplicationsEditForm} />
      <Route>{applicationsView()}</Route>
    </Switch>
  );
};
